angular.module('lf.common')

.controller('AccountCtrl', function ($scope, $rootScope, $popups, accountService, vindiciaService, notificationService, i18n, helpers) {
  var confirmSetCreditCardAsDefaultPopup = 'confirmSetCreditCardAsDefault',
      confirmDeleteCreditCardPopup = 'confirmDeleteCreditCard'; 
  
  $scope.form = lf.data.creditCardFormData && lf.data.creditCardFormData.prepopulate || {};
  $scope.editMode = false;
  
  $scope.filterMonths = function () {
    var now = new Date(),
        currentYear = now.getFullYear(),
        currentMonth = now.getMonth() + 1,
        selectedYear = $scope.form.creditCardExpirationYear.value;

    $scope.months.forEach(function (month) {
      month.disabled = false;
    });

    if (selectedYear === currentYear) {
      $scope.months.forEach(function (month) {
        month.disabled = parseInt(month.value, 10) < currentMonth;
      });
    }
  }
  
  $scope.filterYears = function () {
    var now = new Date(),
        currentYear = now.getFullYear(),
        currentMonth = now.getMonth() + 1,
        selectedMonth = parseInt($scope.form.creditCardExpirationMonth.value, 10);
        firstAvailableYear = $scope.years[0].value;

    $scope.years.forEach(function (year) {
      year.disabled = false;
    });
        
    if (selectedMonth < currentMonth) {
      if (firstAvailableYear === currentYear) {
        $scope.years[0].disabled = true;
      }
      return;
    }

    $scope.years = years;
  }
  
  var years = helpers.creditCardForm.getYears();
  var months =  helpers.creditCardForm.getMonths();
  
  $scope.years = years.slice();
  $scope.months = months.slice();
  
  $scope.savedPaymentInfo = {};
  
  if (typeof lf.data.savedPaymentInfo != 'undefined') {
	  $scope.savedPaymentInfo = lf.data.savedPaymentInfo;
  } else if (typeof lf.data.checkoutData != 'undefined' && typeof lf.data.checkoutData.paymentData != 'undefined') {
	  $scope.savedPaymentInfo = lf.data.checkoutData.paymentData;
  }
  
    
  function autoSelectCard () {
    if (typeof $scope.savedPaymentInfo.creditCards == 'undefined' ||
      !$scope.savedPaymentInfo.creditCards.length) {
      delete $scope.form.selectedCreditCard;
      return;
    }

    $scope.form.selectedCreditCard = $scope.savedPaymentInfo.creditCards[0];
    for (var i = 0; i < $scope.savedPaymentInfo.creditCards.length; i++) {
      if ($scope.savedPaymentInfo.creditCards[i].isDefault) {
        $scope.form.selectedCreditCard = $scope.savedPaymentInfo.creditCards[i];
        break;
      }
    }
  }
  
  autoSelectCard();
  
  $scope.creditCardComparator = function(card) { 
    return card.isDefault ? 0 : 1;
  };
  
  $scope.deleteCreditCard = function() {
    $popups.show(confirmDeleteCreditCardPopup);
  };
  
  $scope.confirmDeleteCreditCard = function() { 
    accountService
      .deleteCreditCard({creditCardId: $scope.form.selectedCreditCard.id})
        .success(function () {
          notificationService.show({text: i18n.notify.creditCardRemovedFromAccount});
        })
        .error(function () {
          notificationService.show({
            text: '<b class="b-red">' + i18n.notify.generalErrorTitle  + '</b><br>' + i18n.notify.generalErrorText,
            error: true
          });
        })
        .finally(function () {
          $popups.hide(confirmDeleteCreditCardPopup);
        });
  };
  
  /*
   * initializeWebSession: 
   * This function initiates the handshake with vindicia for 
   * "Add New Creditcard or "Edit Creditcard" operations 
   */
  $scope.initializeWebSession = function() { 
	  vindiciaService
	  .initializeWebSession()
	  	.success(function (initializeWebSessionResponse, status, headers, config) {
			if(initializeWebSessionResponse.data.success) {
				console.log('Retrieved vindiciaWebSessionId = ' + initializeWebSessionResponse.data.webSessionId);
				$scope.webSessionId = initializeWebSessionResponse.data.webSessionId;
			} else {
				var errorMessage = '<b class="b-red">' + i18n.notify.generalErrorTitle  + '</b><br>' + i18n.notify.generalErrorText;
				notificationService.show({
				      error: true,
				      text: errorMessage
				    });
			}
		})
		.error(function (initializeWebSessionResponse, status, headers, config) {
			var errorMessage = '<b class="b-red">' + i18n.notify.generalErrorTitle  + '</b><br>' + i18n.notify.generalErrorText;
			notificationService.show({
			      error: true,
			      text: errorMessage
			    });
		});
  }

  /*
   * Private function that is reused in both Add New Creditcard and Edit Creditcard flows
   * This function constructs the parameters and invokes vindicia service
   */
  function addOrEditCreditCard(successCallback, errorCallback) { 
	  
	  vindiciaService
		  .addOrEditCreditCard({
			  vinWebSessionMethod: lf.data.creditCardFormData.vindiciaFormHiddenFieldValues.vinWebSessionMethod, //'PaymentMethod_Update',
			  paymentMethodType: lf.data.creditCardFormData.vindiciaFormHiddenFieldValues.paymentMethodType,
			  merchantAccountId: lf.data.creditCardFormData.vindiciaFormHiddenFieldValues.merchantAccountId,
			  webSessionId: (typeof $scope.webSessionId != 'undefined' && $scope.webSessionId != "") ? $scope.webSessionId : lf.data.creditCardFormData.vindiciaFormHiddenFieldValues.webSessionId,
			  paymentMethodId: lf.data.creditCardFormData.vindiciaFormHiddenFieldValues.paymentMethodId,
			  paymentCurrencyCode: lf.data.creditCardFormData.vindiciaFormHiddenFieldValues.paymentCurrencyCode,
			  saveCreditCardInfo: $scope.form.saveCreditCardInfo,
			  setAsDefaultCreditCard: $scope.form.setAsDefaultCreditCard,
			  editCreditCardVID: $scope.form.editCreditCardVID,
			  accountHolderName: $scope.form.accountHolderName,
			  creditCardNumber: $scope.form.creditCardNumber,
			  creditCardExpirationMonth: $scope.form.creditCardExpirationMonth.value,
			  creditCardExpirationYear: $scope.form.creditCardExpirationYear.value,
			  nameValueCvn: $scope.form.creditCardCvn,
			  billingAddress1: $scope.form.billingAddress1,
			  billingAddress2: $scope.form.billingAddress2,
			  billingAddress3: $scope.form.billingAddress3,
			  billingAddressCity: $scope.form.billingAddressCity,
			  billingAddressState: $scope.form.billingAddressState && $scope.form.billingAddressState.value,
			  billingAddressPostalCode: $scope.form.billingAddressPostalCode,
			  billingAddressCountry: lf.data.creditCardFormData.vindiciaFormHiddenFieldValues.billingAddressCountry,
			  billingPhone: $scope.form.billingAddressPhone
		  }, successCallback, errorCallback);
  }
  
  /*
   * Callback function that gets called with "Add Creditcard" operation is successful
   */
  function addCreditCardSuccessCallback (response) {
    // Step 4: Add Creditcard operation was successful. Take the user to successUrl.
    $scope.isRequesting = false;
    window.location = response.data.successUrl;

    // in Desktop site, we need to keep the user on the same page with updated view and notification
    // notificationService.show({text: i18n.notify.creditCardAddedToAccount});
  }
  
  /*
   * Callback function that gets called with "Add Creditcard" operation fails
   */
  function addCreditCardErrorCallback (response) {
    var errorMessage = '';
    
    if (response && response.data && response.data.error && response.data.error && response.data.error.details) {
      errorMessage = response.data.error.details[0];
    } else {
      errorMessage = '<b class="b-red">' + i18n.notify.generalErrorTitle  + '</b><br>' + i18n.notify.generalErrorText;
    }
    
    $scope.addCreditCardHasError = true;
    $scope.addCreditCardErrorMsg = errorMessage;
    
    $scope.isRequesting = false;
    $rootScope.scrollTop();
    
    notificationService.show({
      error: true,
      text: errorMessage
    });
    
    $scope.initializeWebSession();
  }
  
  /*
   * Dummy Add Creditcard Form
   *//*
  $scope.populateAddCreditCardDummyData = function(editMode) {
	  $scope.form = {
			  accountHolderName : "test122003", 
			  creditCardNumber: "4444444444444448", 
			  creditCardExpirationMonth: {value: "10"}, 
			  creditCardExpirationYear: {value: "2025"}, 
			  creditCardCvn: "123",
			  billingAddress1: "5050 Hacienda Drive Apt # 921",
			  billingAddress2: "",
			  billingAddress3: "",
			  billingAddressCity: "Dublin",
			  billingAddressState: {value: "CA"},
			  billingAddressPostalCode: "94568",
			  billingAddressPhone: "5100001111",
			  /* saveCreditCardInfo flag determines whether this creditcard is saved in vindicia account */
			  /*saveCreditCardInfo: true, */
			  /* setAsDefaultCreditCard flag determines whether this creditcard is saved 
			   * as default card in vindicia account 
			   */
			  /*setAsDefaultCreditCard: true*/
		/*};
  }*/
  
  /*
   * addCreditCard: function to be called when user submits "Add New Creditcard" form
   */
  $scope.addCreditCard = function () {
    $scope.isRequesting = true;
    addOrEditCreditCard(addCreditCardSuccessCallback, addCreditCardErrorCallback);
  }
  
  /*
   * Callback function that gets called with "Edit Creditcard" operation is successful
   */
  function editCreditCardSuccessCallback(response) {
	// Step 4: Add Creditcard operation was successful. Take the user to successUrl.
	//window.location = response.data.successUrl;
		
	// in Desktop site, we need to keep the user on the same page with updated view and notification
	// notificationService.show({text: i18n.notify.creditCardAddedToAccount});
  }
  
  /*
   * Callback function that gets called with "Edit Creditcard" operation fails
   */
  function editCreditCardErrorCallback(response) {
	  var errorMessage = "";
	  if(response != "" && typeof response.data != 'undefined' && typeof response.data.error != 'undefined' && typeof response.data.error.details != 'undefined') {
		  errorMessage = response.data.error.details[0];
	  } else {
		  errorMessage = '<b class="b-red">' + i18n.notify.generalErrorTitle  + '</b><br>' + i18n.notify.generalErrorText;
	  }
	  
	  $scope.editCreditCardHasError = true;
	  $scope.editCreditCardErrorMsg = errorMessage;
	  
	  notificationService.show({
      	text: errorMessage,
      	error: true
	  });
  }
  
  /*
   * Dummy Edit Creditcard Form
   *//*
  $scope.populateEditCreditCardDummyData = function(editMode) {
	  $scope.form = {
			  accountHolderName : "test1220", 
			  creditCardNumber: "4444444444444448", 
			  creditCardExpirationMonth: {value: "10"}, 
			  creditCardExpirationYear: {value: "2026"}, 
			  creditCardCvn: "123",
			  billingAddress1: "2390 4th Street",
			  billingAddress2: "",
			  billingAddress3: "",
			  billingAddressCity: "Berkley",
			  billingAddressState: {value: "CA"},
			  billingAddressPostalCode: "94710",
			  billingAddressPhone: "5100001111",
			  /* editCreditCardVID is the ID of the creditcard in vindicia account 
			   * This is required when updating a creditcard
			   */
			  // editCreditCardVID: "b562d30224bc0bb887da3cb3f9c2d83f1dfa164e",
			  /* saveCreditCardInfo flag determines whether this creditcard is saved in vindicia account */
			  /*saveCreditCardInfo: true, */
			  /* setAsDefaultCreditCard flag determines whether this creditcard is saved 
			   * as default card in vindicia account 
			   */
			 // setAsDefaultCreditCard: true
		/*};
  }*/
	  
  /*
   * editCreditCard: function to be called when user submits "Edit Creditcard" form
   */
  $scope.editCreditCard = function ($event) { 
	  addOrEditCreditCard($event, editCreditCardSuccessCallback, editCreditCardErrorCallback);
  }
  
  $scope.setCreditCardAsDefault = function() {
    accountService
      .setCreditCardAsDefault({creditCardId: $scope.form.selectedCreditCard.id})
        .error(function () {
          notificationService.show({
            text: '<b class="b-red">' + i18n.notify.generalErrorTitle + '</b><br>' + i18n.notify.generalErrorText,
            error: true
          });
        })
        .finally(function () {
          $popups.hide(confirmSetCreditCardAsDefaultPopup);
        });
  };
  
  $rootScope.$on('account:creditcards:update', function($event, creditCards) {
    $scope.savedPaymentInfo.creditCards = creditCards;
    autoSelectCard();
  });
});
